/*

  # Modal auto open

  Co-controller which causes a modal to open immediately.

  <div data-hook="modal modalAutoOpen">
    ...
  </div>

*/

import { assignController, controllersAvailable, getControllers } from '../api/element-manipulation'

assignController('modalAutoOpen', (element) => {
  controllersAvailable(() => {
    const { modal } = getControllers(element)
    if (!modal) {
      return
    }
    setTimeout(modal.open, 100)
  })
})
